import { Expand } from "@store/Framework/Types/Common";
import constants from "./constants";
import * as use from "./hooks";
import * as map from "./mappers";
import push from "./push";
import * as track from "./trackers";
import * as util from "./utilities";

export interface GoogleAnalytics {
    constants: typeof constants;
    debug: boolean;
    defaultPropertyName: string;
    delayTracking: (fn?: () => any, timeout?: number) => void;
    enabled: boolean;
    map: Expand<typeof map>;
    push: typeof push;
    track: Expand<typeof track>;
    use: Expand<typeof use>;
    util: Expand<typeof util>;
}

const ga: Toolkit.GoogleAnalytics = {
    constants: constants as Toolkit.GoogleAnalytics["constants"],
    debug: false,
    delayTracking: fn => {
        fn?.();
    },
    defaultPropertyName: "data",
    enabled: true,
    map: map as Toolkit.GoogleAnalytics["map"],
    push,
    track: track as Toolkit.GoogleAnalytics["track"],
    use: use as Toolkit.GoogleAnalytics["use"],
    util: util as Toolkit.GoogleAnalytics["util"],
};

export default ga;
